import { FC, useState, ReactNode, useRef, useCallback, useEffect, useMemo } from 'react';
import './style.scss';
import {
    Button,
    Upload,
    UploadProps,
    message,
    UploadFile,
    Tooltip,
    Modal,
    ModalProps,
    notification,
    Radio
} from 'antd';
// import type { CheckboxValueType } from 'antd/es/checkbox/Group';
import {
    UploadOutlined,
    EyeOutlined,
    FileOutlined,
    DeleteOutlined,
    EditFilled
} from '@ant-design/icons';
import { uploadApi, imgUploadApi, saveApi } from '../../api';
import { FileType } from '../enum';
import Draggable from 'react-draggable';
import type { DraggableData, DraggableEvent } from 'react-draggable';

import { passWordFiled, createPdf } from '../../utils';
import { formSchemaData } from '../application/data';

import ImgPreview from '../imgPreview';
import ApplyList from '../applyList';
import SampleList from '../sampleList';
// import ProveList from '../proveList';

type TableData = {
    fileName: string;
    uploadResult?: UploadFile<File>[];
    type: FileType;
};

interface PropsType {
    next: (index: number, key?: string, patam?: any) => void;
    nextParam: Record<string, any>;
    options: Record<string, any>[];
    tableData: TableData[];
    setTableData: (e: any) => void;
}

const Material: FC<PropsType> = ({
    next = () => {},
    nextParam = {},
    tableData = [],
    setTableData = () => {},
    options = []
}) => {
    const columns = [
        {
            title: '序号',
            width: '5%',
            filed: 'index'
        },
        {
            title: '材料名称',
            width: '30%',
            filed: 'fileName'
        },
        {
            title: '操作',
            width: '15%',
            filed: 'bz'
        }
    ];
    const [open, setOpen] = useState(false);
    const [selectOpen, setSelectOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [ModalContent, setModalContent] = useState<ReactNode>(null);
    const [modalProps, setModalProps] = useState<ModalProps>({});
    const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 });
    const draggleRef = useRef<HTMLDivElement>(null);
    const [api, contextHolder] = notification.useNotification();
    const [imgIndex, setImgIndex] = useState<number>(0);
    const [zjIndex, setZJIndex] = useState<string>('1');
    const [demoType, setDemoType] = useState<string | null>(null);
    const [imgData, setImgData] = useState<Record<string, any>[]>([]);
    const [bannerImg, setBannerImg] = useState<any[]>([]);
    const [checkValue, setCheckValue] = useState<string>('');

    function getMediaOptions() {
        const data = options.filter(({ type }) => type === 'media');
        return data;
    }

    const checkOptions = useMemo<string[]>(() => {
        const mediaOptions = getMediaOptions();
        const filterOpt = mediaOptions.filter(({ dictBn }) =>
            nextParam?.applicationData?.appData?.media?.includes(dictBn)
        );
        return filterOpt.map(({ name }) => name);
    }, [nextParam.applicationData.appData]);

    useEffect(() => {
        if (!open) return;
        setImgData(
            zjIndex === '1'
                ? [
                      {
                          url: require('../../img/2.png'),
                          title: '医疗机构执业许可证[正本] (示例) ↑↑↑'
                      },
                      {
                          url: require('../../img/1.png'),
                          title: '医疗机构执业许可证[副本] (示例) ↑↑↑'
                      }
                  ]
                : [
                      {
                          url: require('../../img/3.jpg'),
                          title: '诊所备案凭证 (示例) ↑↑↑'
                      },
                      {
                          url: require('../../img/4.jpg'),
                          title: '中医诊所备案证 (示例) ↑↑↑'
                      }
                  ]
        );
    }, [zjIndex, open]);

    useEffect(() => {
        showExample('banner');
    }, []);

    const openNotification = (title: string) => {
        api.warning({
            message: title,
            // description: '',
            placement: 'topRight',
            top: 300
        });
    };

    const [bannerImgs, setBannerImgs] = useState<Record<string, any>[]>([]);

    useEffect(() => {
        if (!bannerImgs.length || !bannerImgs[imgIndex]) return;
        const { index } = bannerImgs[imgIndex];
        const [item] = tableData.filter(({ type }) => type === FileType.BANNER);
        const uploadResult = item?.uploadResult || [];
        setCheckValue((uploadResult[index] as any).yj_type || '');
    }, [imgIndex, bannerImgs]);

    const uplodaProps: UploadProps = {
        customRequest: async ({ file, data: param }) => {
            try {
                updateFileList(file as UploadFile, param);
                message.success('文件上传成功！');
            } catch (error) {
                message.error('文件上传失败！');
            }
        },
        beforeUpload: (file ) => {
            // const {uploadResult} = tableData[0]
            // if((uploadResult?.length || 0) > 0 ) {
            //     message.error('请合并样式表为一个PDF！');
            //     return false;
            // }
            const imgs = ['image/png', 'image/JPEG', 'image/jpg', 'image/jpeg'];
            const isImg = imgs.includes(file.type);
            if (!isImg)
                message.error(`${file.name} 文件格式不支持，请上传(png/jpg/jpeg)格式的图片`);
            return isImg || Upload.LIST_IGNORE;
        },
        fileList: [],
        multiple: true
    };

    // 更新文件上传列表
    function updateFileList(file: UploadFile, data: Record<string, unknown> | undefined = {}) {
        const newData = tableData.map((item) => {
            if (item.type === data.type) item.uploadResult?.push(file);
            return { ...item };
        });
        setTableData(newData);
        // 添加类型选择
        if (data.type === FileType.BANNER) openImgModel();
    }

    // 保存进入下一步
    async function submit() {
        const { applicationData } = nextParam;
        const { appData } = applicationData;
        // 预审材料检查
        const result = materialTest(tableData);
        if (!result.state) return message.error(result.message);
        // 上传初始化
        setLoading(true);
        openNotification('材料自动生成提交中，请勿离开！');

        // 生成预审材料图片base,传入PDF
        const imgData = await createImgData(tableData);

        const time = setTimeout(async () => {
            try {
                const apply = await createPdf(
                    <ApplyList data={appData} options={options} />,
                    '四川省中医医疗广告审查申请表'
                );
                const sample = await createPdf(
                    <SampleList data={appData} options={options} imgData={imgData} />,
                    '四川省中医医疗广告成品样件表'
                );
                // 四川省中医医疗广告审查申请表
                const applyFiles = await uploadApi(apply);
                // 上传医疗广告成品样件表
                const sampleFiles = await uploadApi(sample);

                next(4, 'materialResult', {
                    data: nextParam.applicationData.result,
                    applyFiles: applyFiles?.data,
                    sampleFiles: sampleFiles?.data
                });
            } catch (error) {
                setLoading(false);
                message.error(`提交预审失败！`);
            }
            clearTimeout(time);
        }, 14);
    }

    // 预审材料检查
    function materialTest(data: TableData[]) {
        let result: Record<string, any> = { state: true };
        const types: string[] = [];

        const imgFiles = data.filter(
            ({ uploadResult }) => !!uploadResult && !!uploadResult?.length
        );
        if (imgFiles.length < 1) return { message: '缺少必要预审材料！', state: false };

        imgFiles.forEach((item) => {
            result[item.type] = item.uploadResult;
            if (item.type !== FileType.BANNER) return;
            item.uploadResult?.forEach((file: Record<string, any>) => {
                if (!file?.yj_type)
                    result = { message: '广告成品样件缺少发布类型！', state: false };
                if (file?.yj_type) types.push(file?.yj_type);
            });
        });

        if (Array.from(new Set(types)).length !== nextParam?.applicationData?.appData?.media.length)
            result = { message: '广告样件媒体类型不正确！', state: false };

        return result;
    }

    // 加载文件生成base64
    async function readFileAsDataURL(file: UploadFile<File> | null) {
        if (!file) return;
        let result_base64 = await new Promise((resolve) => {
            let fileReader = new FileReader();
            fileReader.onload = (e) => resolve(fileReader.result);
            fileReader.readAsDataURL(file as any);
        });
        return result_base64;
    }

    // 生成样件成品图片数据
    async function createImgData(tableData: TableData[]) {
        const [itemData] = tableData.filter((item) => item.type === FileType.BANNER);
        const data: Record<string, any>[] = [];
        for (let i = 0; i < (itemData.uploadResult?.length || 0); i++) {
            const file = itemData?.uploadResult ? itemData?.uploadResult[i] : null;
            const url = await readFileAsDataURL(file);
            data.push({ url, type: [(file as any)?.yj_type] });
        }
        return data;
    }

    // 删除文件
    async function deleteFile(param: any) {
        tableData.forEach(({ type, uploadResult = [] }, index) => {
            if (type !== param.type) return;
            const i = uploadResult?.findIndex((item) => item.name === param.name);
            if (i === -1) return false;
            tableData[index].uploadResult?.splice(i as number, 1);
            return false;
        });
        setTableData([...tableData]);
    }

    // 渲染文件上传组件
    function renderUpload(data: Record<string, unknown>, uploadResult: UploadFile[]): ReactNode {
        const renderTile: ReactNode = uploadResult.length ? (
            <div className='file-list-box'>
                {uploadResult.map(({ name, uid }) => (
                    <div className='file-item' key={uid}>
                        <FileOutlined />
                        <span className='file-name' title={name}>
                            {name}
                        </span>
                        <div
                            className='del-item'
                            title='删除'
                            onClick={deleteFile.bind(null, { name, type: data.type })}
                        >
                            <DeleteOutlined />
                        </div>
                    </div>
                ))}
                <div style={{ textAlign: 'center', padding: '8px 0' }}>
                    <Button size='small' onClick={openImgModel} ghost icon={<EditFilled />}>
                        媒体类型
                    </Button>
                </div>
            </div>
        ) : null;

        return (
            <Tooltip title={renderTile} placement='bottom' color='#0094fe'>
                <Upload {...uplodaProps} data={data} className='upload-box'>
                    <Button type='primary' size='small' style={{ fontWeight: 'bold' }}>
                        <UploadOutlined style={{ fontSize: '16px' }} />
                        上传({uploadResult?.length})
                    </Button>
                </Upload>
            </Tooltip>
        );
    }
    // 显示参考示例
    const showExample = (type: string) => {
        setDemoType(type + 'Example');
        setModalContent(null);
        setModalProps({
            width: 1000,
            className: 'ant-modal-body-example',
            title:
                type === FileType.PERMIT ? (
                    <span style={{ color: 'red' }}>根据医疗机构所持证件情况，上传相关证件</span>
                ) : null
        });
        setOpen(true);
    };
    // 图片及PDF预览
    const showPreview = useCallback(
        async (type: FileType) => {
            switch (type) {
                case FileType.APPLY:
                    setModalContent(
                        <ApplyList options={options} data={nextParam.applicationData.appData} />
                    );
                    break;
                case FileType.SAMPLE:
                    const imgData = await createImgData(tableData);
                    setModalContent(
                        <SampleList
                            options={options}
                            data={nextParam.applicationData.appData}
                            imgData={imgData}
                        />
                    );
                    break;
                case FileType.BANNER:
                case FileType.PERMIT:
                    const [item] = tableData.filter((item) => item.type === type);
                    if (!item.uploadResult || item.uploadResult.length === 0) return false;
                    setModalContent(<ImgPreview uploadResult={item.uploadResult} />);
                    break;
            }
            setDemoType(null);
            setModalProps({
                width: type === FileType.BANNER || type === FileType.PERMIT ? 600 : 1000,
                className: 'ant-modal-body-preview'
            });
            setOpen(true);
        },
        [tableData]
    );
    // 取消隐藏弹窗
    const handleCancel = () => {
        setOpen(false);
        setSelectOpen(false);
    };
    // 保存类别
    function saveType() {
        setSelectOpen(false);
    }

    // 打开图片媒体类型弹窗
    function openImgModel() {
        setSelectOpen(true);
        const [item] = tableData.filter(({ type }) => type === FileType.BANNER);
        const uploadResult = item?.uploadResult || [];
        const newData: Record<string, any>[] = [];
        setBannerImg(uploadResult);
        setImgIndex(uploadResult.length - 1);
        uploadResult.forEach((file, index) => {
            let reader = new FileReader();
            reader.readAsDataURL(file as any);
            reader.onload = (e: any) => {
                newData.push({ url: e.target.result, index });
                if (newData.length === uploadResult.length) setBannerImgs(newData);
            };
        });
    }

    const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
        const { clientWidth, clientHeight } = window.document.documentElement;
        const targetRect = draggleRef.current?.getBoundingClientRect();
        if (!targetRect) {
            return;
        }
        setBounds({
            left: -targetRect.left + uiData.x,
            right: clientWidth - (targetRect.right - uiData.x),
            top: -targetRect.top + uiData.y,
            bottom: clientHeight - (targetRect.bottom - uiData.y)
        });
    };

    function preClick() {
        if (imgIndex <= 0) return;
        setImgIndex(imgIndex - 1);
    }

    function nextClick() {
        if (imgIndex >= bannerImg.length - 1) return;
        setImgIndex(imgIndex + 1);
    }

    const onCheckedChange = (index: number, value: string) => {
        setCheckValue(value);
        const newData = tableData.map((item) => {
            if (item.type === FileType.BANNER && item.uploadResult)
                (item.uploadResult[index] as any).yj_type = value;
            return { ...item };
        });
        setTableData(newData);
    };

    return (
        <div className='box material-box'>
            {contextHolder}
            <div className='text-title'>
                <span className='line'></span>
                <span>广告样件模板</span>
            </div>
            <div className='text-title-line'></div>
            <div>
                <table className='table table-responsive' align='center'>
                    <tbody>
                        <tr>
                            {columns.map(({ title, width, filed }) => (
                                <td className='bl-bg text-tag' width={width} key={filed}>
                                    {title}
                                </td>
                            ))}
                        </tr>
                    </tbody>
                    <tbody className='text-tag'>
                        {tableData.map(({ fileName, uploadResult, type }, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>
                                    {fileName}
                                    {type === FileType.BANNER ? (
                                        <span style={{ color: 'red', fontWeight: 'bold' }}>
                                            （必传）
                                        </span>
                                    ) : null}
                                </td>
                                <td>
                                    {index < 1 ? renderUpload({ type }, uploadResult || []) : null}
                                    {index < 1 ? (
                                        <>
                                            <span
                                                className='btn'
                                                onClick={showExample.bind(null, type)}
                                            >
                                                参考示例
                                            </span>
                                            <span
                                                style={{
                                                    margin: '0px 8px',
                                                    borderLeft: '2px solid #aaa'
                                                }}
                                            ></span>
                                        </>
                                    ) : null}
                                    <span
                                        style={{ margin: 0 }}
                                        className='btn'
                                        onClick={showPreview.bind(null, type)}
                                    >
                                        <EyeOutlined />
                                        预览
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div>
                <Button
                    onClick={() => next(2)}
                    type='primary'
                    style={{ width: 140, marginTop: 15, height: 35, marginRight: 15 }}
                    disabled={loading}
                >
                    上一步
                </Button>
                <Button
                    onClick={submit}
                    loading={loading}
                    type='primary'
                    style={{
                        width: 140,
                        marginTop: 15,
                        height: 35,
                        backgroundColor: '#FFC000',
                        border: 'none'
                    }}
                >
                    下一步
                </Button>
            </div>

            <Modal
                title={null}
                open={open}
                footer={null}
                {...modalProps}
                onCancel={handleCancel}
                destroyOnClose={true}
                modalRender={(modal) => (
                    <Draggable
                        bounds={bounds}
                        nodeRef={draggleRef}
                        onStart={(event, uiData) => onStart(event, uiData)}
                    >
                        <div ref={draggleRef}>{modal}</div>
                    </Draggable>
                )}
            >
                {demoType === FileType.BANNER + 'Example' ? (
                    <div>
                    <img
                        src={require('../../img/ggyj.jpg')}
                        className='ck-view-img'
                        draggable='false'
                        alt='参考示例'
                    />
                    <div style={{ marginBottom: '15px', fontWeight: 'bold',color: 'red' }}>
                    发布媒体为影视或广播，还需单独将音频和视频发至电子邮箱zyyzfc979@163.com
                    </div>
                    </div>
                ) : null}
                {demoType === FileType.PERMIT + 'Example' ? (
                    <>
                        <div className='w-full top-btn-box'>
                            <Radio.Group
                                value={zjIndex}
                                onChange={(e) => setZJIndex(e.target.value)}
                            >
                                <Radio.Button value='1'>情况1：医疗机构执业许可证</Radio.Button>
                                <Radio.Button value='2'>情况2：诊所证件</Radio.Button>
                            </Radio.Group>
                        </div>
                        <div className='img-box w-full'>
                            {zjIndex === '1' ? (
                                <div
                                    style={{
                                        textAlign: 'left',
                                        padding: '10px 30px',
                                        fontSize: '16px'
                                    }}
                                >
                                    需上传
                                    <span style={{ color: 'red' }}>
                                        《医疗机构执业许可证(正本)》
                                    </span>
                                    和
                                    <span style={{ color: 'red' }}>
                                        《医疗机构执业许可证 (副本)》
                                    </span>
                                    ，详见下方示例:
                                </div>
                            ) : (
                                <div
                                    style={{
                                        textAlign: 'left',
                                        padding: '10px 30px',
                                        fontSize: '16px'
                                    }}
                                >
                                    需上传<span style={{ color: 'red' }}>《中医诊所备案证》</span>或
                                    <span style={{ color: 'red' }}>《诊所备案凭证》</span>
                                    ，详情见下方示例:
                                </div>
                            )}

                            {imgData.map(({ url, title }, index) => (
                                <>
                                    <img
                                        src={url}
                                        className='ck-view-img'
                                        draggable='false'
                                        alt='参考示例'
                                    />
                                    <div style={{ marginBottom: '15px', fontWeight: 'bold' }}>
                                        {title}
                                    </div>
                                </>
                            ))}
                        </div>
                    </>
                ) : null}
                {ModalContent}
            </Modal>

            <Modal
                {...modalProps}
                title={null}
                open={selectOpen}
                footer={null}
                onCancel={handleCancel}
                destroyOnClose={true}
                width={650}
                modalRender={(modal) => (
                    <Draggable
                        bounds={bounds}
                        nodeRef={draggleRef}
                        onStart={(event, uiData) => onStart(event, uiData)}
                    >
                        <div ref={draggleRef}>{modal}</div>
                    </Draggable>
                )}
            >
                <div className='banner-img-view-box' style={{ height: 300, width: 600 }}>
                    <img src={bannerImgs[imgIndex]?.url} draggable='false' alt='' />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <span style={{ marginRight: '10px' }}>广告样件发布媒体类别：</span>
                    <Radio.Group
                        value={checkValue}
                        onChange={(e) =>
                            onCheckedChange(bannerImgs[imgIndex]?.index, e.target.value)
                        }
                    >
                        {checkOptions.map((text, index) => (
                            <Radio value={text} key={index}>
                                {text}
                            </Radio>
                        ))}
                    </Radio.Group>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <Button
                        type='primary'
                        style={{ marginRight: 15 }}
                        onClick={preClick.bind(null)}
                        disabled={imgIndex === 0}
                    >
                        上一张
                    </Button>
                    {imgIndex >= bannerImg.length - 1 ? (
                        <Button type='primary' onClick={saveType.bind(null)}>
                            确定
                        </Button>
                    ) : (
                        <Button type='primary' onClick={nextClick.bind(null)}>
                            下一张
                        </Button>
                    )}
                </div>
            </Modal>
        </div>
    );
};

export default Material;
